import {
	OBJECT_GRAPH_SIDE_PANEL_MIN_WIDTH,
	OBJECT_GRAPH_SIDE_PANEL_MAX_WIDTH,
} from './constants.tsx';
import type { ResizeBounds } from './types.tsx';

export function getResizeBounds(): ResizeBounds {
	return {
		min: `${OBJECT_GRAPH_SIDE_PANEL_MIN_WIDTH}px`,
		max: `${OBJECT_GRAPH_SIDE_PANEL_MAX_WIDTH}px`,
	};
}
